<template>
    <div>
        <b-modal id="cp" title="Додати до чорного списку" v-model="modalShow" centered @shown="focusMyElement">
            <b-form-input v-model="edrpou" ref="focusThis" maxlength="10" placeholder="Вкажіть ЄДРПОУ" pattern="[0-9]" @keypress="isNumber($event)"></b-form-input>
            <template slot="modal-footer" slot-scope="{ ok, cancel }">
                <b-button variant="success"
                          ref="SaveBt"
                          @click="add">Додати
                </b-button>
                
                <b-button variant="primary" @click="modalShow=false">Закрити
                </b-button>
            </template>
        </b-modal>
    </div>
</template>

<script>


export default {
    name: "counterparty_add",
    
    components: {},
    props: {},
    
    data() {
        return {
            edrpou: '',
            modalShow: false
        }
    },
    
    created() {
        EventBus.$on('add_counterparty',this.show_add_modal)
    },
    
    methods: {
        show_add_modal() {
            this.edrpou = '';
            this.modalShow = true;
        },
        
        isNumber(evt) {
            let keysAllowed = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
            let keyPressed = evt.key;
            if (!keysAllowed.includes(keyPressed)) {
                
                if (evt.keyCode === 13) {
                    this.focusSaveBt()
                }
                evt.preventDefault()
            }
        },
        
        focusMyElement() {
            this.edrpou = '';
            this.$refs.focusThis.focus()
        },
        
        focusSaveBt() {
            this.$refs.SaveBt.focus()
        },
        
        async add() {
            
            await api.put('/counterparty',{
                "edrpou": this.edrpou,
                "name": this.name
            }).then(({data}) => {
                if (data.status == "operation_success") {
                    EventBus.$emit('show_toast', {err: 'Додано', type: "success", title: ''});
                    EventBus.$emit('added_cp');
                    this.modalShow = false;
                }
            }).catch(err => {
                EventBus.$emit('show_toast', {err: err.message, type: "danger", title: err.name})
            });
        },
        
        
    },
    watch: {},
    
    
}
</script>

<style scoped>

</style>
